// TODO: Replace this module-level Twilio state with a React context/hook in a future refactor.
import { Call, Device } from '@twilio/voice-sdk';

let device: Device | undefined;
let activeCall: Call | undefined;

export const getTwilioDevice = (): Device | undefined => {
    return device;
};

export const setTwilioDevice = (nextDevice: Device): void => {
    device = nextDevice;
};

export const getActiveTwilioCall = (): Call | undefined => {
    return activeCall;
};

export const setActiveTwilioCall = (nextCall: Call | undefined): void => {
    activeCall = nextCall;
};

export const destroyTwilioDevice = (): void => {
    if (activeCall) {
        activeCall.disconnect();
        activeCall = undefined;
    }

    if (device) {
        device.destroy();
        device = undefined;
    }
};